import './text-chart.scss';
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import {useContext} from 'react';
import {AppContext} from '../../../contexts/app/context';
import {AppContextType} from '../../../contexts/app/types';
import {ThemeMode} from '../../../enums/theme-mode';
import RefreshIcon from '@mui/icons-material/Refresh';
import {ErrorBox} from '../../error-box/error-box';
import {Pallete} from '../../../theme/bluebird';

/**
 * Text chart used in the statistics dashboards.
 */
export const TextChart = (props: {
  title: string;
  loading: boolean;
  handleRefresh?: () => void;
  value?: string | number;
  subtitle?: string;
  unitLabel?: string;
  error?: string;
}) => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  // Get theme
  const theme = useTheme();

  return (
    <Card
      className="text-chart-container"
      variant="outlined"
      sx={{
        border: 'none',
        boxShadow: '0px 4px 16px 0px rgba(29, 41, 57, 0.15)',
        backgroundColor:
          appContext.state.currentThemeMode === ThemeMode.Light
            ? Pallete.white.base
            : theme.palette.background.paper,
      }}
    >
      <CardContent className="text-chart-content-container">
        {props.loading ? (
          <Box
            // 34px: Fontsize of the typography used for the value
            // 1.235px: Line height of the typography used for the value
            sx={{
              height: `${(34 * 1.235).toFixed(2)}px`,
            }}
            className="text-chart-content-circular-progress-container"
          >
            <CircularProgress color="primary" size={24} />
          </Box>
        ) : props.value !== undefined &&
          props.value !== null &&
          props.value !== '' &&
          !props.error ? (
          <Typography
            variant="h6"
            color="primary.main"
            component="span"
            className="text-chart-content-value"
          >
            {typeof props.value === 'number'
              ? `${props.value.toFixed(props.unitLabel ? 2 : 0)} ${props.unitLabel || ''}`
              : `${props.value} ${props.unitLabel || ''}`}
          </Typography>
        ) : (
          <Box
            // 34px: Fontsize of the typography used for the value
            // 1.235px: Line height of the typography used for the value
            sx={{
              height: `${(34 * 1.235).toFixed(2)}px`,
            }}
          />
        )}
        <Typography variant="body1" component="span" className="text-chart-content-title">
          {props.title}
        </Typography>
        {props.subtitle && (
          <Typography
            variant="subtitle2"
            component="span"
            color="#464646"
            className="text-chart-content-subtitle"
          >
            {props.subtitle}
          </Typography>
        )}
        {props.error && !props.loading && (
          <Box className="text-chart-error-box">
            <ErrorBox error={props.error} />
          </Box>
        )}
      </CardContent>
      {!props.loading && props.handleRefresh && (
        <Box className="text-chart-refresh-button">
          <IconButton onClick={props.handleRefresh}>
            <RefreshIcon />
          </IconButton>
        </Box>
      )}
    </Card>
  );
};
